<template>
  <div>
    <div class="changeModel" @click="showDrawer">
      <a-icon type="appstore" style="font-size: 14px" />
      <span>切换模块</span>
    </div>
    <a-drawer
      title="切换模块"
      placement="left"
      :closable="false"
      @close="onClose"
      :visible="visible"
      width="300"
    >
      <!--<a-card-->
      <!--hoverable-->
      <!--v-for="i in 20"-->
      <!--:key="i"-->
      <!--&gt;-->
      <a-card :bordered="false">
        <a-card-grid
          style="padding:5px 0;cursor:pointer;width:33%;textAlign:'center'"
          v-for="item in modelLists"
          :key="item.label"
          @click="goModel(item.path)"
        >
          <a-icon :type="item.icon" class="ico" />
          <div class="title">{{ item.label }}</div>
        </a-card-grid>
      </a-card>

      <!--</a-card>-->
    </a-drawer>
  </div>
</template>

<script>
var modelLists = [
  { icon: 'desktop', label: '首页', path: 'Main/Manage/Census' },
  { icon: 'notification', label: '报题管理', path: 'Main/Report/ReportList' },
  { icon: 'sound', label: '宣传指令', path: 'Main/Direct/DirectList' },
  { icon: 'tags', label: '标引管理', path: 'Main/Task/TagList' },
  { icon: 'code', label: '任务管理', path: 'Main/Task/TaskList' },
  { icon: 'file', label: '任务稿件', path: 'Main/Draft/ArticleList' },
  { icon: 'team', label: '网友爆料', path: 'Main/Data/YcNumber' },
  { icon: 'area-chart', label: '任务情况', path: 'Main/Task/TaskProgressList' },
  { icon: 'cloud', label: '资源库', path: 'Main/Cloud/Picture' },
  { icon: 'file-sync', label: '云稿库', path: 'Main/Article/Lists' },
  { icon: 'reconciliation', label: '内容管理', path: 'Main/Article/Add' },
  { icon: 'appstore', label: '栏目管理', path: 'Main/Article/Cate' },
  { icon: 'chrome', label: '媒体号', path: 'Main/Data/YcNumber' },
  { icon: 'ie', label: '全网数据', path: 'Main/Data/Bigdata?id=4' },
  { icon: 'wechat', label: '双微数据', path: 'Main/Data/Wechat/Wx' },
  {
    icon: 'deployment-unit',
    label: '媒体发布',
    path: 'Main/Third/MediaPublishSetting'
  },
  { icon: 'database', label: '其他设置', path: 'Main/ThirdParty/Tel' },
  {
    icon: 'notification',
    label: '广告服务',
    path: 'Main/Advertisement/Manage'
  },
  {
    icon: 'mobile',
    label: 'app设置',
    path: 'Main/mobile/AppList'
  },
  // {
  //   icon: 'wechat',
  //   label: '微信文章',
  //   path: 'main/WxPull/Channel'
  // }
  { icon: 'highlight', label: '专题模板', path: 'Main/Thematic/Drag' },
  // { icon: 'build', label: '栏目权限', path: 'Main/CateManage/GroupManger' }
  // {
  //   icon: 'pushpin',
  //   label: '区域文章',
  //   path: 'Main/RegionArticle/ArticleListTop'
  // }
  {
    icon: 'block',
    label: '系统日志',
    path: 'Main/Logs/Examine'
  }
];
if (
  window.localStorage.getItem('siteinfo') != null &&
  window.localStorage.getItem('siteinfo') != ''
) {
  let siteinfo = JSON.parse(window.localStorage.getItem('siteinfo'));
  if (siteinfo.role_id <= 2) {
    modelLists.push(
      {
        icon: 'build',
        label: '栏目权限',
        path: 'Main/CateManage/Authority'
      },
      {
        icon: 'wechat',
        label: '微信文章',
        path: 'main/WxPull/Channel'
      }
    );
  }
  if (siteinfo.site_id == 2) {
    modelLists.push({
      icon: 'pushpin',
      label: '区域文章',
      path: 'Main/RegionArticle/ArticleListTop'
    });
  }
}

export default {
  data() {
    return {
      modelLists,
      visible: false
    };
  },
  methods: {
    goModel(path) {
      if (path != '') {
        this.visible = false;
        setTimeout(() => {
          this.$router.push('/' + path);
        }, 500);
      } else {
        this.$message.error('路由不存在');
      }
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    }
  }
};
</script>

<style scoped>
.changeModel {
  padding: 0 20px;
  line-height: 50px;
  height: 50px;
  cursor: pointer;
}
.changeModel a {
  color: #fff;
}
.changeModel:hover {
  background-color: rgba(238, 240, 240, 0.1);
}
.changeModel span {
  margin: 0 10px;
}
div.ant-drawer-content-wrapper
  > div.ant-drawer-content
  > div.ant-drawer-wrapper-body
  > div.ant-drawer-body {
  padding: 0;
}
/*.ant-card {*/
/*width: 80px;*/
/*height: 80px;*/
/*float:left;*/
/*margin:3px;*/
/*}*/
/*.ant-card>>>div.ant-card-body {*/
/*padding:0;*/
/*}*/
.ico {
  margin-top: 10px;
  font-size: 32px;
  line-height: 40px;
  width: 100%;
}
.title {
  width: 100%;
  text-align: center;
}
</style>
